// import axios from 'axios';
import QS from 'qs';
import Vue from 'vue';
import host from '../utils/host';
import host2 from '../utils/host2';
import $http from '../utils/http';
import $http_upload from '../utils/http_upload';
//import protobuf from 'protobufjs';
import protoRoot from '../../static/proto/proto';
import { createRouter } from '../router';

let commonParam = {
    langNumber: 3,//语言标识(公共参。1=简 2=繁 3=英 4=韩 5=泰 6=越 7=日本).
    platform: 4,//平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
    portType: 1,//平台(公共参。1=Android, 2=iOS, 3=webapp, 4=pc).
    sportType: 1,//1足球2篮球(非公共参)
}
export function socketRes(data) {
    var buf = new Uint8Array(data);

    var modelResponse = protoRoot.lookupType("model.Response");
    var response = modelResponse.decode(buf);

    return response;
}

// 比分websocket开启
export function footballListOpen(_$socket, ver) {
    if (typeof (window) == 'undefined') {
        return;
    }

    var subscribe = {
        type: 101,
        scoreVersion: ver, //这个版本号从API那里拿，然后回传
    };
    subscribe = { ...commonParam, ...subscribe }
    var lookType = protoRoot.lookupType('model.Subscribe');
    var subEncode = lookType.create(subscribe);
    var buffer = lookType.encode(subEncode).finish();
    console.log('开启', buffer)
    _$socket.send(buffer);
    console.log("发送listOpen", subscribe);
};

export function getSocket(_this, obj) {
    if (typeof (window) == 'undefined') {
        return;
    }
    var subscribe = {
        type: 111,
        //scoreVersion: ver, //这个版本号从API那里拿，然后回传
        matchId: '',
    };
    subscribe = { ...commonParam, ...subscribe, ...obj }
    var lookType = protoRoot.lookupType('model.Subscribe');
    var subEncode = lookType.create(subscribe);
    var buffer = lookType.encode(subEncode).finish();
    console.log('开启', buffer)
    _this.$socket.send(buffer);
    console.log("发送listOpen", subscribe);
};

export function getSocketFootballListUpdate(data) {
    var dataBuf = data;
    var modelData = protoRoot.lookupType("model.FootballListUpdate");
    var decData = modelData.decode(dataBuf);

    return decData;
};
//Socket更新包二进制转换
export function getSocketUpdate(data, name) {
    var dataBuf = data;
    var modelData = protoRoot.lookupType("model." + name);
    var decData = modelData.decode(dataBuf);

    return decData;
};

// 获取排行榜
export function getPredictionRank(params) {
    const url = host() + 'prediction/version/1_0/predictionRank';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.PredictionRank");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 获取热门比赛预测
export function getListHot(params) {
    const url = host() + 'prediction/version/1_1/listHot';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballPredictionList");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 获取比赛预测列表
export function getListByDate(params) {
    const url = host() + 'prediction/version/1_1/listByDate';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballPredictionDateList");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 获取新闻最新10条
export function getNewsListLast(params) {
    const url = host() + 'news/version/1_0/listLast';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.NewsListLast");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 获取用户信息, 可判断是否登录
export function getUser(params) {
    const url = host() + 'user/version/1_0/getUser';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            if (response.state == 400 || response.state == 403) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.UserInfoItem");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 邮箱登录
export function getEmailLogin(params) {
    const url = host() + 'user/version/1_0/login/email';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state == 400) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.UserInfoItem");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 邮箱注册
export function getEmailSignUp(params) {
    const url = host() + 'user/version/1_0/register/email';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 忘记密码
export function getForgotPwd(params) {
    const url = host() + 'user/version/1_0/forgetPwd';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 重设密码
export function getResetPwd(params) {
    const url = host() + 'user/version/1_0/resetPwd';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 修改密码
export function getResetPassword(params) {
    const url = host() + 'user/version/1_0/resetPassword';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};
// 上传头像
export function getAvatarUpload(params) {
    const url = host() + 'user/version/1_0/avatar/upload';

    $http.headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'multipart/form-data'
    }

    return new Promise((resolve, reject) => {
        $http.post(url, params).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            var dataBuf = response.data.value;
            var modelFootballLeagueFixture = protoRoot.lookupType("model.UploadImageInfo");
            var pointsData = modelFootballLeagueFixture.decode(dataBuf);
            response.data = pointsData;
            resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 修改头像和昵称
export function getAvatarEdit(params) {
    const url = host() + 'user/version/1_0/avatar/edit';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 第三方登录
// google、facebook登录
export function getThirdLogin(url, params) {
    const userAgent = navigator.userAgent;
    $http.headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'User-Agent': userAgent
    }
    $http.responseType = 'json';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
           
            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};
// apple登录
export function getAppleLogin(params) {
    const url = host() + 'user/version/1_0/login/oauth/apple_callback';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};
// google登录中转
export function getGoogleCallback(params) {
    const url = host() + 'user/version/1_0/login/oauth/callback';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state == 400 || response.state == 403) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.UserInfoItem");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// tiktok登录中转
export function getTiktokCallback(params) {
    const url = host() + 'user/version/1_0/tiktok/oauth/callback';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state == 400 || response.state == 403) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.UserInfoItem");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 创建海报
export function getNewPoster(params) {
    const url = host() + 'prediction/version/1_0/newPoster';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state == 400 || response.state == 403) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballListUpdate");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 获取海报列表
export function getUserPoster(params) {
    const url = host() + 'prediction/version/1_0/userPoster';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballPredictionPosterList");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 删除海报
export function getDelPoster(params) {
    const url = host() + 'prediction/version/1_0/delPoster';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 获取海报详细
export function getPosterDetail(params) {
    const url = host() + 'prediction/version/1_0/posterDetail';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state == 400 || response.state == 403) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballPredictionPoster");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 更新海报PV和UV
export function getVisitPoster(params) {
    const url = host() + 'prediction/version/1_0/visitPoster';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 更新海报联赛点击数
export function getVisitPosterLeague(params) {
    const url = host() + 'prediction/version/1_0/visitPosterLeague';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};

// 获取广告列表
export function getListAd(obj) {
    var params = {
        pageId: 1,
        userToken: '',
    };
    params = { ...commonParam, ...params, ...obj }
    const url = host() + 'webAd/version/1_0/listAd';

    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.WebAd");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 邮箱订阅
export function getEmailSubscribe(params) {
    const url = host() + 'user/version/1_0/subscribe/email';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};
// 广告点击量
export function getAdHits(obj) {
    var params = {
        id: 1,
        userToken: '',
    };
    params = { ...commonParam, ...params, ...obj }

    const url = host() + 'webAd/version/1_0/hits';

    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};
// 获取seo配置
export function getSEO(obj) {
    var params = {
        type: 1,
        userToken: '',
    };
    params = { ...commonParam, ...params, ...obj }

    const url = host() + 'setting/version/1_0/seo';

    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.Seo");
            var resData = modelData.decode(dataBuf);
            response.data = resData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

/* 比赛内页 */
export function getMatchInfo(params) {
    const url = host() + 'match/version/1_1/footballMatch/matchInfo';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            // console.log("getMatchInfo-response", response);
            if (response.state == 400) {
                createRouter().push({ path: '/404' })
            }
            var dataBuf = response.data.value;
            var modelFootballList = protoRoot.lookupType("model.FootballMatchInfo");

            var footballList = modelFootballList.decode(dataBuf);
            //console.log("footballList", footballList);
            response.data = footballList;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });

};

/* 新闻 */
// 新闻-分类
export function getNewsCategory(params) {
    const url = host() + 'news/version/1_0/listCategory';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            var dataBuf = response.data.value;
            var modelFootballLeagueFixture = protoRoot.lookupType("model.CategoryList");
            var pointsData = modelFootballLeagueFixture.decode(dataBuf);
            response.data = pointsData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};
// 新闻-列表
export function getListNews(params) {
    const url = host() + 'news/version/1_0/listNews';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            var dataBuf = response.data.value;
            var modelFootballLeagueFixture = protoRoot.lookupType("model.NewsList");
            var pointsData = modelFootballLeagueFixture.decode(dataBuf);
            response.data = pointsData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 新闻-详细
export function getNewsDetail(params) {
    const url = host() + 'news/version/1_0/detail';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            // console.log(response,'response')
            if (response.state == 400) {
                createRouter().push({ path: '/404' })
            }
            var dataBuf = response.data.value;
            var modelFootballLeagueFixture = protoRoot.lookupType("model.News");
            var pointsData = modelFootballLeagueFixture.decode(dataBuf);
            response.data = pointsData;
            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 新闻点击量
export function getNewsInfoHits(obj) {
    var params = {
        id: 1,
        userToken: '',
    };
    params = { ...commonParam, ...params, ...obj }

    const url = host() + 'news/version/1_0/hits';

    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            return resolve(response);

        }, err => {
            reject(err)

        }).catch(err => {
            reject(err)
        })
    });
};
/* 新闻 */

// 邮箱订阅文案
export function getSubscribeEmailIntro(params) {
    const url = host() + 'user/version/1_0/subscribe/emailIntro';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state != 200) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.Intro");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 预测-详细
export function getPredictionDetail(params) {
    const url = host() + 'prediction/version/1_1/detail';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            if (response.state != 200) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballPredictionDetailV2");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 关联列表
export function getPredictionRelateMatch(params) {
    const url = host() + 'prediction/version/1_1/relateList';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            if (response.state != 200) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballPredictionRelateMatch");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
}


// 模型更新记录
export function getFootballUpdateLog(params) {
    const url = host() + 'prediction/version/1_0/updateLog';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);

            if (response.state != 200) {
                return resolve(response);
            }

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballUpdateLog");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
}

// 首页预测模型统计
export function getHomeStat(params) {
    const url = host() + 'prediction/version/1_1/homeStat';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballPredictionHomeStat");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 获取首页预测列表
export function getListHome(params) {
    const url = host() + 'prediction/version/1_1/listHome';
    params = { ...commonParam, ...params }
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            var res = response;
            var apiBuf = new Uint8Array(res.data);
            //return apiBuf;
            //console.log(apiBuf)
            var modelResponse = protoRoot.lookupType("model.Response");
            var response = modelResponse.decode(apiBuf);
            //console.log("response", response);

            var dataBuf = response.data.value;
            var modelData = protoRoot.lookupType("model.FootballPredictionList");
            var resData = modelData.decode(dataBuf);
            response.data = resData;

            resolve(response);

        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};


// WEBPACK FOOTER //
// ./src/api/api.js